export default {
  getAllTrackedRoutes: state => state.allTrackedRoutes,
  getShowTrack: state => state.showTrack
}
